import React, { useState, useEffect } from 'react';
import { getScannerResults } from '../../services/BeholderService';
import { processError } from '../../services/ServiceUtils';

const REGIME_COLORS = {
    RANGING:         'bg-info text-dark',
    TRENDING_UP:     'bg-success',
    TRENDING_DOWN:   'bg-danger',
    HIGH_VOLATILITY: 'bg-warning text-dark'
};

const REGIME_LABELS = {
    RANGING:         'Lateral',
    TRENDING_UP:     'Tendência ↑',
    TRENDING_DOWN:   'Tendência ↓',
    HIGH_VOLATILITY: 'Alta Vol.'
};

function formatVolume(v) {
    if (!v) return '—';
    if (v >= 1e9) return (v / 1e9).toFixed(1) + 'B';
    if (v >= 1e6) return (v / 1e6).toFixed(1) + 'M';
    if (v >= 1e3) return (v / 1e3).toFixed(0) + 'K';
    return v.toString();
}

function ScannerResults() {
    const [data, setData] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    function load() {
        setLoading(true);
        getScannerResults()
            .then(result => { setData(result); setLoading(false); })
            .catch(err => { setError(processError(err)); setLoading(false); });
    }

    useEffect(() => { load(); }, []);

    if (loading) return null;
    if (error || !data || !data.results || !data.results.length) return null;

    const scannedAt = data.timestamp ? new Date(data.timestamp).toLocaleTimeString() : '—';

    return (
        <div className='card card-body border-0 shadow mt-4'>
            <div className='d-flex justify-content-between align-items-center mb-3'>
                <h6 className='mb-0'>
                    <svg className='icon icon-xs me-2' fill='currentColor' viewBox='0 0 20 20'>
                        <path fillRule='evenodd' d='M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z' clipRule='evenodd' />
                    </svg>
                    Scanner de Mercado — Melhores Oportunidades
                </h6>
                <small className='text-muted'>
                    {data.scanned} analisados ({data.quote} / {data.interval}) · {scannedAt}
                    <button className='btn btn-sm btn-link py-0 ms-2' onClick={load}>↻</button>
                </small>
            </div>
            <div className='table-responsive'>
                <table className='table table-hover table-sm mb-0'>
                    <thead>
                        <tr className="align-middle">
                            <th>Símbolo</th>
                            <th>Regime</th>
                            <th>Confiança</th>
                            <th>ADX</th>
                            <th>ATR%</th>
                            <th>Vol 24h</th>
                            <th>Pontuação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.results.map(r => (
                            <tr key={r.symbol}>
                                <td><strong>{r.symbol}</strong></td>
                                <td>
                                    <span className={`badge ${REGIME_COLORS[r.regime] || 'bg-secondary'} py-1`}>
                                        {REGIME_LABELS[r.regime] || r.regime}
                                    </span>
                                </td>
                                <td>{r.confidence !== undefined ? (r.confidence * 100).toFixed(0) + '%' : '—'}</td>
                                <td>{r.adx !== null ? r.adx : '—'}</td>
                                <td>{r.atrPerc !== undefined ? r.atrPerc + '%' : '—'}</td>
                                <td>{formatVolume(r.volume24hUsd)}</td>
                                <td>
                                    <span className={`badge py-1 ${r.score >= 40 ? 'bg-success' : r.score >= 25 ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                                        {r.score}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ScannerResults;
